import { Tool } from '../../types';

export const fieldServiceTools: Tool[] = [
  {
    id: 'jobber',
    name: 'Jobber',
    category: 'Field Service',
    description: 'Business management software for service businesses',
    pricing: ['medium', 'high'],
    features: ['scheduling', 'invoicing', 'mobile', 'job-tracking'],
    bestFor: ['trades', 'small-business'],
    compatibleWith: ['service-business', 'trades'],
    goals: ['streamline-operations', 'manage-scheduling'],
    industries: ['trades', 'home-services'],
    website: 'https://go.getjobber.com/j5exzglusf2r',
    imageUrl: 'https://logo.clearbit.com/getjobber.com',
    idealStages: ['launching', 'growing', 'scaling'],
    technicalLevel: ['beginner', 'intermediate'],
    minTeamSize: 'solo'
  },
  {
    id: 'servicetitan',
    name: 'ServiceTitan',
    category: 'Field Service',
    description: 'All-in-one software for home and commercial service businesses',
    pricing: ['high'],
    features: ['scheduling', 'invoicing', 'mobile', 'job-tracking', 'automation', 'integrations'],
    bestFor: ['trades', 'small-business'],
    compatibleWith: ['service-business', 'trades'],
    goals: ['streamline-operations', 'manage-scheduling', 'increase-sales', 'automate-tasks'],
    industries: ['trades', 'home-services'],
    website: 'https://www.servicetitan.com',
    imageUrl: 'https://logo.clearbit.com/servicetitan.com',
    idealStages: ['growing', 'scaling'],
    minTeamSize: 'medium',
    technicalLevel: ['intermediate', 'advanced']
  }
];